import React, { useState, useEffect } from 'react';
import { useProjectStore } from '../../stores/projectStore';
import { Dialog } from '../common/Dialog';
import { Button } from '../common/Button';
import { WorkspaceId } from '../../../types';
import * as styles from './RenameWorkspaceDialog.css.ts';

interface RenameWorkspaceDialogProps {
  isOpen: boolean;
  workspaceId: WorkspaceId;
  currentName: string;
  onClose: () => void;
}

export const RenameWorkspaceDialog: React.FC<RenameWorkspaceDialogProps> = ({
  isOpen,
  workspaceId,
  currentName,
  onClose,
}) => {
  const [newName, setNewName] = useState(currentName);
  const renameWorkspace = useProjectStore((state) => state.renameWorkspace);

  useEffect(() => {
    setNewName(currentName);
  }, [currentName, isOpen]);

  const handleRename = () => {
    if (!newName.trim() || newName === currentName) return;

    renameWorkspace(workspaceId, newName.trim());
    onClose();
  };

  const handleClose = () => {
    setNewName(currentName);
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Rename Workspace"
      width="md"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleRename}
            disabled={!newName.trim() || newName === currentName}
          >
            Rename
          </Button>
        </>
      }
    >
      <div className={styles.form}>
        <input
          className={styles.input}
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="Enter new name"
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleRename();
          }}
        />
      </div>
    </Dialog>
  );
};